import { useAppSelector } from "app/hooks";
import { SelectInput } from "components/FormControls/Select/Select";
import { maxVisibleConditionDataCount } from "components/Layout/Segment/SegmentForm/SegmentForm";
import { MoreElements } from "components/MoreElements/MoreElements";
import { useMessage } from "hooks/intl";
import { get } from "lodash";
import { getCountries } from "reduxState/settings/settings";
import { Country } from "types/segments";
import { useStyles } from "./SegmentConditions.styles";

export const initialValuesCountry: Country = {
  countries: [],
  type: "country",
};

export function CountryList({
  formField,
  values,
  readOnly,
}: {
  formField: string;
  values: any;
  readOnly?: boolean;
}) {
  const { message } = useMessage();
  const countriesList = useAppSelector(getCountries);

  const formFieldName = `${formField}.countries`;

  const countryListItems = (countriesList || []).map(({ name, code }) => ({
    label: name,
    id: code,
  }));
  const value = get(values, formField);
  const classes = useStyles();

  return (
    <>
      {value.isConditionSaved || readOnly ? (
        <>
          {message({ id: "is_one_of" }).toLocaleLowerCase()}{" "}
          {value?.countries
            ?.slice(0, maxVisibleConditionDataCount)
            ?.map((country: string, index: number) => (
              <div className={classes.box} key={index}>
                {countryListItems.find((item) => item.id === country)?.label ||
                  country}
              </div>
            ))}
          <MoreElements
            totalItemsNumber={value?.countries?.length}
            tooltipData={{
              type: "labels",
              data: value.countries
                ?.slice(maxVisibleConditionDataCount)
                ?.map(
                  (countryIso: string) =>
                    countryListItems.find(
                      (country) => country.id === countryIso,
                    )?.label,
                ),
            }}
          />
        </>
      ) : (
        <SelectInput
          displaySearch
          multiple
          data-test-id="segment-form-conditions-country-select"
          width="100%"
          items={countryListItems}
          label={message({ id: "country" })}
          name={formFieldName}
          placeholder={message({ id: "country" })}
        />
      )}
    </>
  );
}
